import styled from 'styled-components';

export const TopicOverviewWrapper = styled.div``;
